import {
    ACCORDION_ITEM_CONTENT_INNER_CLASSNAME,
    ACCORDION_ITEM_DETAILS_ID_PREFIX,
} from '@vfde-brix/ws10/accordion';
import {
    closeAccordion,
    footnoteAccordion,
} from './accordion';
import {
    getCMSConfig,
    showAllTariffFootnotesAtOnce,
} from '../util/cms';
import {
    getTariffFoonoteItemIndex,
    getUpdatedAccordionItemProps,
} from '../util/components/accordion.util';
import { replaceTariffPlaceholders } from '../util/formatter';
import { getTextBeforeFootnoteLink } from '../util/brixElement';
import { trackFootnoteLink } from '@vfde-sails/tracking';
import {
    toggleElementsVisibilityById,
    toggleElementVisibilityById,
} from '@vfde-brix/ws10/core';
import { JarvisProducts } from '../interface';
import { ContentId } from '../enums/elementId';

export const FOOTNOTE_LINK_CLASSNAME = 'ws10-footnote-link-style';

const clickHandler = (target: EventTarget | null, selectedId: string) => {
    if (!footnoteAccordion || !target || !(target instanceof HTMLElement)) {
        return;
    }

    const { items } = footnoteAccordion.getProperties();
    const index = +target.innerText - 1;
    const item = items[index];

    if (!item) {
        return;
    }

    trackFootnoteLink(getTextBeforeFootnoteLink(target));
    closeAccordion(footnoteAccordion);

    footnoteAccordion.toggleItemById(item.stdId, true);

    setTariffFoonoteContentVisibility(selectedId);
};

/**
 * Mounts every sup html footnote link elements on the page
 */
export const mountFootnoteLinks = (selectedId: string) => {
    for (const footnoteLink of document.getElementsByTagName('sup')) {
        footnoteLink.addEventListener('click', ({ target }) => clickHandler(target, selectedId));
    }
};

/**
 * Displays only the selected tariff's footnote and hide the others.
 *
 * @param tariffId The ID of the selected tariff
 */
export const setTariffFoonoteContentVisibility = (tariffId: string) => {
    if (!footnoteAccordion || showAllTariffFootnotesAtOnce()) {
        return;
    }

    const { footnoteHtmlIds } = getCMSConfig().footnotes;
    const htmlId: string | undefined = footnoteHtmlIds[tariffId];

    toggleElementsVisibilityById(Object.values(footnoteHtmlIds), false);
    toggleElementVisibilityById(htmlId, true);
};

/**
 * Replaces the placeholders with real data in the tariff footnote
 */
const replaceTariffFootnotePlaceholders = (tariffs: JarvisProducts) => {
    const { footnoteHtmlIds } = getCMSConfig().footnotes;

    for (const tariffId of Object.keys(footnoteHtmlIds)) {
        const tariff = tariffs[tariffId];

        if (!tariff) {
            continue;
        }

        const footnoteEl = document.getElementById(footnoteHtmlIds[tariff.id]);

        if (!footnoteEl) {
            continue;
        }

        footnoteEl.innerHTML = replaceTariffPlaceholders(footnoteEl.innerHTML, tariff);
    }
};

const getUpdatedFootnoteAccordionContentHTML = (tariffs: JarvisProducts): string => {
    // Note: 1.) Replaces every placeholders in tariff footnote item of the the footnote accordion
    replaceTariffFootnotePlaceholders(tariffs);

    // Note: 2.) Gets the updated Element of the tariff footnote
    const [tariffFootnoteEl] = document.getElementById(`${ACCORDION_ITEM_DETAILS_ID_PREFIX}${ContentId.TariffFootnoteAccordionItem}`)
        ?.getElementsByClassName(ACCORDION_ITEM_CONTENT_INNER_CLASSNAME) || [];

    // Note: 3.) Return the innerHTML of the updated Element for the Brix Accordion update
    return tariffFootnoteEl?.innerHTML ?? '';
};

/**
 * Loads the fetched footnote content into the footnote accordion item
 */
export const initTariffFootnotes = (tariffs: JarvisProducts) => {
    const index = getTariffFoonoteItemIndex();

    if (index === null) {
        return;
    }

    const formattedContent = getUpdatedFootnoteAccordionContentHTML(tariffs);

    // Note: Update with the updated/formatted text on init
    footnoteAccordion?.update(getUpdatedAccordionItemProps(
        footnoteAccordion,
        index,
        formattedContent,
    ));
};
